import React, {PropTypes} from 'react';
import {Menu} from 'react-data-grid-addons';
import {I18n} from 'react-redux-i18n';

const {ContextMenu, MenuItem} = Menu;

class ArticlesContext extends React.Component {
	onRowCopy = (e, data) => {
		this.props.onRowCopy(e, data);
	}

	onRowDelete = (e, data) => {
		this.props.onRowDelete(e, data);
	}

	render() {
		return (
      <ContextMenu>
        <MenuItem data={{rowIdx: this.props.rowIdx, idx: this.props.idx}} onClick={this.onRowCopy}>{I18n.t('DUPLICATE_ROW')}</MenuItem>
        <MenuItem data={{rowIdx: this.props.rowIdx, idx: this.props.idx}} onClick={this.onRowDelete}>{I18n.t('CLEAR_ROW')}</MenuItem>
      </ContextMenu>
    );
  }
}

ArticlesContext.propTypes = {
	idx: PropTypes.number,
	rowIdx: PropTypes.number,
	onRowDelete: PropTypes.func.isRequired,
	onRowCopy: PropTypes.func.isRequired
};


export default ArticlesContext;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/ArticlesContext.js
 **/